/** Matches backend assertAdmin: Designation.SUPER_ADMIN or Department.ADMIN */
export const isEmailConfigAdmin = (user?: { department?: string; designation?: string } | null): boolean => {
	if (!user) return false;
	const designation = (user.designation || '').toLowerCase().replace(/[_\s-]+/g, '');
	const department = (user.department || '').toLowerCase().replace(/[_\s-]+/g, '');
	return designation.includes('superadmin') || department === 'admin';
};

export const formatEmailConfigName = (name?: string): string => {
	if (!name) return '—';
	return name
		.split('_')
		.map(part => part.charAt(0) + part.slice(1).toLowerCase())
		.join(' ');
};
